import { render } from "./Quickpay.vue?vue&type=template&id=24446bda&scoped=true"
import script from "./Quickpay.vue?vue&type=script&lang=js"
export * from "./Quickpay.vue?vue&type=script&lang=js"

import "./Quickpay.vue?vue&type=style&index=0&id=24446bda&lang=scss"
import "./Quickpay.vue?vue&type=style&index=1&id=24446bda&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24446bda"]])

export default __exports__